import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/Input";
import Typography from "@material-ui/core/Typography";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TextField from "@material-ui/core/TextField";

import SignIn from "./SignIn.jsx";
import CustomizedSnackbar from "../Snackbar/CustomizedSnackbar.jsx";

import RunnersTable from "../DataTables/RunnersTable.jsx";
import MessagesTable from "../DataTables/MessagesTable.jsx";
import RaceResultsTable from "../DataTables/RaceResultsTable.jsx";
import AddResultDialog from "../Dialogs/AddResultDialog.jsx";
import DeleteResultDialog from "../Dialogs/DeleteResultDialog.jsx";

import AttachFileIcon from "@material-ui/icons/AttachFile";
import PublishIcon from "@material-ui/icons/Publish";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import MessageIcon from "@material-ui/icons/Message";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import ScreenShareIcon from "@material-ui/icons/ScreenShare";
import ArchiveIcon from "@material-ui/icons/Archive";
import AddToQueue from "@material-ui/icons/AddToQueue";
import RemoveFromQueue from "@material-ui/icons/RemoveFromQueue";

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
// import Papa from "papaparse";
import moment from "moment";
import ReactGA from "react-ga";

const styles = theme => ({
  gridItem: {
    padding: 10,
    margin: 10,
    maxWidth: "100%"
  },
  button: {
    textTransform: "none",
    margin: 10
  },
  body1: {
    margin: 10
  },
  fullWidth: {
    width: "100%"
  },
  tableDiv: {
    maxWidth: "100%"
  },
  tablePanelWrapper: {
    padding: 0
  },
  textField: {
    width: 300
  },
  card: {
    backgroundColor: theme.palette.white,
    margin: 10,
    marginRight: 0,
    marginLeft: 0,
    borderRadius: 10
  },
  cardContent: {
    margin: 20
  }
});

class Webmaster extends React.Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      usersData: [],
      usersTableData: [],
      commentsTableData: {},
      leagueData: [null],
      loadingLastRace: false,
      eventsParticipation: [],
      raceDate: this.findMonday().format("YYYY-MM-DD"),
      // eslint-disable-next-line
      category: { ["Male"]: {}, ["Female"]: {} }
    };
  }

  componentWillMount = () => {
    this._mounted = true;
    setTimeout(() => {
      this.countParticipation();
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          if (
            user.email.indexOf("idanmantzor") !== -1 ||
            user.email.indexOf("dsterhaar") !== -1
          ) {
            this.setState({ authenticated: true, loaded: true });
            ReactGA.set({ userId: user.email.split("@")[0] });
            this.triggerListeners();
          } else {
            this.setState({
              authenticated: false,
              volunteer: true,
              loaded: true
            });
            ReactGA.set({ userId: user.email.split("@")[0] });
          }
          window.user = user;
        } else {
          ReactGA.set({ userId: "runner" });
          this.setState({ authenticated: false, loaded: true });
          window.user = undefined;
        }
      });
      this.triggerListeners();
    }, 1000);
  };

  componentDidMount = () => {
    this.setState({ el: document.getElementById(".some-element") });
    //this.fixEarlyTimerFire();
  };

  componentWillUnmount = () => {
    this._mounted = false;
    firebase
      .database()
      .ref()
      .off();
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      prevState.usersTableData !== this.state.usersTableData ||
      prevState.leagueData !== this.state.leagueData
    ) {
      if (this.state.leagueData.length && this.state.usersTableData) {
        const { leagueData, usersTableData } = this.state;
        usersTableData.forEach((row, index) => {
          if (leagueData && leagueData[row[0]] && leagueData[row[0]].events) {
            usersTableData[index].push(
              Object.keys(leagueData[row[0]].events).length
            );
          } else {
            usersTableData[index].push(0);
          }
          this.setState({ usersTableData });
        });
      }
    }
  };

  findMonday = () => {
    const dayToFind = moment()
      .day("Monday")
      .weekday();
    const monday = moment();
    while (monday.weekday() !== dayToFind) {
      monday.subtract(1, "day");
    }
    console.log(monday.format("YY"));
    return monday;
  };

  fixEarlyTimerFire = () => {
    var date = "2019-06-24";
    var offset = 3825;
    var results;
    //4839 - 1014 = 3825
    firebase
      .database()
      .ref(`raceResults/${date}/numeric`)
      .once("value", snapshot => {
        results = snapshot.val();
        Object.keys(results).forEach(key => {
          var finishTime = this.getSeconds(results[key].finishTime);
          if (finishTime > offset) {
            if (finishTime < 3600) {
              results[key].finishTime = moment()
                .startOf("day")
                .seconds(finishTime - offset)
                .format("mm:ss");
            } else {
              results[key].finishTime = moment()
                .startOf("day")
                .seconds(finishTime - offset)
                .format("HH:mm:ss");
            }
            console.log(results[key].finishTime);
          }
        });

        console.log(results);
      })
      .then(() => {
        //firebase
        // .database()
        // .ref(`raceResults/${date}/numeric`)
        // .update(results);
      });
  };

  getTargetGroup = () => {
    // var match = []
    // var emails = ""
    // firebase.database().ref("usersLeague").once("value", league => {
    //   league.val().forEach(user => {
    //     if (user.pb < "35:01") {
    //       match.push(user.bibNumber)
    //     }
    //   })
    // }).then(() => {
    //   firebase.database().ref("users").once("value", users => {
    //     console.log(users.val())
    //     match.forEach(bib => {
    //       if (users.val()[bib]){
    //         emails += users.val()[bib].email + " ,"
    //       }else {
    //         console.log(bib)
    //       }
    //     })
    //   }).then(() => {console.log(emails)})
    // }
    // )
  };

  countParticipation = () => {
    var eventsParticipation = Array(100).fill(0);

    firebase
      .database()
      .ref("usersLeague")
      .once("value", snap => {
        var leagueData = snap.val();
        var countEvent = Array(leagueData.length).fill(0);
        leagueData.forEach((row, index) => {
          if (row.events) {
            Object.keys(row.events).forEach(key => {
              countEvent[index]++;
            });
          }
        });
        countEvent.forEach(row => {
          eventsParticipation[row]++;
        });
        this.setState({ eventsParticipation, leagueData });
      })
      .then(() => {
        var totalDistance = 0;
        eventsParticipation.forEach((row, index) => {
          totalDistance += index * row;
        });
        this.setState({ totalDistance });
        firebase
          .database()
          .ref("totalDistance")
          .set(totalDistance);
      });
  };

  triggerListeners = () => {
    const commentsRef = firebase.database().ref("comments");
    var usersTableData = [];
    firebase
      .database()
      .ref("raceDates")
      .once("value", snapshot => {
        this.setState({ events: snapshot.val() });
      });
    firebase
      .database()
      .ref("users")
      .once("value", users => {
        users.val().forEach(u => {
          const minor =
            moment(u.dob, "YYYY-MM-DD")
              .fromNow()
              .split(" ")[0] < 18;
          usersTableData.push([
            u.bibNumber,
            u.firstName,
            u.surname,
            u.dob,
            u.idNumber,
            u.gender,
            u.email,
            u.phone,
            u.nationality,
            u.volunteer === true ? "Yes" : "No",
            u.timeRegistered,
            u.registrationEmail === true
              ? `Sent ${minor ? "(minor)" : ""}`
              : minor
              ? "Need Consent"
              : "Needed"
          ]);
        });
        this.setState({ usersTableData });
      });

    commentsRef.on("child_added", user => {
      this.setState(prevState => {
        if (!user.val().deleted) {
          prevState.commentsTableData[user.key] = user.val();
        }
        return prevState;
      });
    });
  };

  logoutUser = () => {
    firebase
      .auth()
      .signOut()
      .then(
        () => {
          this.triggerSnackbar("Signed Out", "success");
        },
        error => {
          this.triggerSnackbar("Sign out error", "error");
          console.error("Sign Out Error", error);
        }
      );
  };
  loadFromFile = () => {
    // var csvFilePath = this.state.csvFilePath
    //   ? this.state.csvFilePath
    //   : require("./csvFile.csv");
    // // if (!this.state.csvFilePath) {
    // //   this.notify("Please select a csv file first");
    // //   return
    // // }
    // Papa.parse(csvFilePath, {
    //   header: true,
    //   download: true,
    //   skipEmptyLines: true,
    //   complete: this.updateData
    // });
  };

  updateData = results => {
    if (results.errors.length > 0) {
      this.triggerSnackbar("Failed to parse csv file", "error");
      return;
    }
    var parsedResultsTableData = { CSV: [] };
    var unparsedResults = [];
    results.data.forEach(row => {
      if (row.Bib !== "") {
        unparsedResults.push(row);
        parsedResultsTableData.CSV.push([
          "-",
          "-",
          row.Bib,
          row.Name,
          row.Category,
          row["Predicted time"]
        ]);
      }
    });
    this.setState({ parsedResultsTableData, unparsedResults });
    this.triggerSnackbar("CSV file loaded", "success");
  };

  downloadDatabase = () => {
    window.open(
      "https://ggc5km.firebaseio.com/.json?print=pretty&format=export&download=ggc5km-export.json&auth=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhZG1pbiI6dHJ1ZSwiZXhwIjoxNTQ4MTUwMTYxLCJpYXQiOjE1NDgxNDY1NjEsInYiOjB9.bJKDyn224SZUa2JziYdZOd11xVdU906lcx4tcTey8sk"
    );
  };

  loadLastRace = () => {
    const db = firebase.database();

    var runners;
    var result = {};
    var flatten = {};
    this.setState({ loadingLastRace: true });

    db.ref("users")
      .once("value", snapshot => {
        runners = snapshot.val();
        runners.shift();
      })
      .then(() => {
        db.ref("raceResults")
          .orderByKey()
          .limitToLast(1)
          .once("child_added", race => {
            var scanner = race.val().scanner;
            var scanned = scanner && scanner.scanned;
            var tapper = race.val().tapper;
            const numeric = race.val().numeric;

            if (numeric) {
              // Numeric Keypad
              result["Keypad only"] = [];
              var numericSorted = [];

              //Sort - needed for late start
              Object.keys(numeric).forEach(res => {
                numericSorted.push([numeric[res], numeric[res].finishTime]);
              });

              numericSorted.sort((a, b) => {
                if (a[1] === "-" || b[1] === "-") return -1;
                var t1 = this.getNumberFromTime(a[1]);
                var t2 = this.getNumberFromTime(b[1]);
                return t1 - t2;
              });
              numericSorted.forEach((row, index) => {
                var runner = runners[row[0].bibNumber - 1];

                if (!runner) {
                  runner = {
                    bibNumber: 0,
                    firstName: "Guest",
                    surname: "",
                    gender: "-",
                    dob: "-",
                    ts: row[0].clockTime
                  };
                }
                const categoryAndPosition = this.getCategoryAndPosition(
                  runner.gender,
                  runner.dob
                );
                result["Keypad only"].push([
                  index + 1,
                  categoryAndPosition.position,
                  runner.bibNumber,
                  `${runner.firstName} ${runner.surname}`,
                  categoryAndPosition.category,
                  row[0].finishTime,
                  row[0].clockTime
                ]);
              });

              if (tapper) {
                //numeric && tapper
                Object.keys(tapper).forEach(key => {
                  result["Keypad and " + key] = [];
                });
                this.setState(prevState => {
                  Object.keys(prevState.category.Male).forEach(ageGroup => {
                    if (prevState.category.male)
                      prevState.category.male[ageGroup] = 0;
                  });
                  Object.keys(prevState.category.Female).forEach(ageGroup => {
                    if (prevState.category.female)
                      prevState.category.female[ageGroup] = 0;
                  });
                  return prevState;
                });

                Object.keys(numeric).forEach((key, index) => {
                  const row = numeric[key];
                  var runner = runners[row.bibNumber - 1];
                  if (!runner) {
                    runner = {
                      bibNumber: 0,
                      firstName: "No",
                      surname: "number",
                      gender: "-",
                      dob: "-",
                      ts: row.clockTime
                    };
                  }

                  const categoryAndPosition = this.getCategoryAndPosition(
                    runner.gender,
                    runner.dob
                  );

                  Object.keys(tapper).forEach(key => {
                    if (tapper[key].results[index])
                      result["Keypad and " + key].push([
                        index + 1,
                        categoryAndPosition.position,
                        runner.bibNumber,
                        `${runner.firstName} ${runner.surname}`,
                        categoryAndPosition.category,
                        tapper[key].results[index],
                        row[0].clockTime
                      ]);
                  });
                });
              }
            } else {
              // QR scanner & tapper
              if (!tapper) {
                this.triggerSnackbar("No data is found", "error");
                return;
              }
              Object.keys(tapper).forEach((tp, index) => {
                tapper[tp].results.reverse();
                result[tp] = [];
                Object.keys(scanned).forEach(key => {
                  flatten[Object.keys(scanned[key])[0]] =
                    scanned[key][Object.keys(scanned[key])[0]];
                });
                const orderedTimeStamps = Object.keys(flatten).sort();
                orderedTimeStamps.forEach((ts, index) => {
                  const runner = runners[flatten[ts] - 1];
                  if (runner === undefined) {
                    const runner = {};
                    const categoryAndPosition = {
                      category: "n/a",
                      position: 0
                    };
                    runner.bibNumber = "99999";
                    runner.firstName = "No";
                    runner.surname = "QR";
                    if (result[tp]) {
                      result[tp].push([
                        index + 1,
                        categoryAndPosition.position,
                        runner.bibNumber,
                        `${runner.firstName} ${runner.surname}`,
                        categoryAndPosition.category,
                        tapper[tp].results[index]
                          ? tapper[tp].results[index]
                          : "-"
                      ]);
                      // console.log(tapper[tp].results[index], tapper[tp].results);
                    }
                  } else {
                    const categoryAndPosition = this.getCategoryAndPosition(
                      runner.gender,
                      runner.dob
                    );
                    if (result[tp]) {
                      result[tp].push([
                        index + 1,
                        categoryAndPosition.position,
                        runner.bibNumber,
                        `${runner.firstName} ${runner.surname}`,
                        categoryAndPosition.category,
                        tapper[tp].results[index]
                          ? tapper[tp].results[index]
                          : "-"
                      ]);
                      // console.log(tapper[tp].results[index], tapper[tp].results);
                    }
                  }
                });
              });
            }
          })
          .then(() => {
            this.setState({
              loadingLastRace: false,
              parsedResultsTableData: result
            });
            console.log(result);
            // this.publishPersonalResults(result["Keypad only"]);
          });
      });
  };

  getNumberFromTime = time => {
    var splitted = time.split(":");
    if (splitted.length === 2) {
      return Number(splitted[0] * 60) + Number(splitted[1]);
    }
    if (splitted.length === 3) {
      return (
        Number(splitted[0] * 3600) +
        Number(splitted[1] * 60) +
        Number(splitted[2], time)
      );
    }
  };

  getCategoryAndPosition = (gender, dob) => {
    var position = 0;
    if (gender === "-" || dob === "-") {
      return { category: "-", position: "-" };
    }
    const ageGroup = this.getAgeGroup(dob);
    this.setState(prevState => {
      if (prevState.category[gender][ageGroup]) {
        prevState.category[gender][ageGroup] += 1;
      } else {
        prevState.category[gender][ageGroup] = 1;
      }
      position = prevState.category[gender][ageGroup];
      return prevState;
    });
    return {
      category: `${gender} ${this.getAgeGroup(dob)}`,
      position: position
    };
  };

  getAgeGroup = dob => {
    const age = moment(dob, "YYYY-MM-DD")
      .fromNow()
      .split(" ")[0];
    if (age < 10) {
      return "0-9";
    } else if (age > 9 && age < 16) {
      return "10-15";
    } else if (age > 15 && age < 20) {
      return "16-19";
    } else if (age > 19 && age < 30) {
      return "20-29";
    } else if (age > 29 && age < 40) {
      return "30-39";
    } else if (age > 39 && age < 50) {
      return "40-49";
    } else if (age > 49 && age < 60) {
      return "50-59";
    } else if (age > 59 && age < 70) {
      return "60-69";
    } else if (age > 69 && age < 80) {
      return "70-79";
    } else if (age > 79 && age < 90) {
      return "80-89";
    } else {
      return " >90";
    }
  };

  triggerSnackbar = (message, variant) => {
    this.setState({
      snackbarMessage: message,
      snackbarVariant: variant,
      snackbarTrigger: true,
      submmiting: false,
      submmitingComment: false
    });
  };

  onSnackbarClose = () => {
    this.setState({ snackbarTrigger: false });
  };

  getSeconds = t => {
    var sp = t.split(".")[0].split(":");
    if (t === "-") return 0;
    if (sp.length === 2) return Number(sp[0] * 60) + Number(sp[1]);
    return Number(sp[0]) * 3600 + Number(sp[1]) * 60 + Number(sp[2]);
  };

  calcStats = resultsData => {
    const res = resultsData;
    const totalRunners = res.length;
    var categoryData = { series: [], labels: [] };
    var genderData = {
      untimed: [0, 0],
      series: [0, 0],
      labels: ["Male", "Female"],
      averageTimes: [0, 0]
    };
    res.forEach(row => {
      var label;
      if (row[4].indexOf("Female") !== -1) {
        genderData.series[1] += 1;
        genderData.averageTimes[1] += this.getSeconds(row[5]);
        label = "F" + row[4].split(" ")[1];
        if (row[5] === "-") genderData.untimed[1] += 1;
      } else if (row[4].indexOf("Male") !== -1) {
        genderData.series[0] += 1;
        genderData.averageTimes[0] += this.getSeconds(row[5]);
        label = "M" + row[4].split(" ")[1];
        if (row[5] === "-") genderData.untimed[0] += 1;
      }

      if (categoryData.labels.indexOf(label) === -1) {
        categoryData.labels.push(label);
        categoryData.series.push(1);
      } else {
        categoryData.series[categoryData.labels.indexOf(label)] += 1;
      }
    });
    genderData.labels[0] += ` ${Math.round(
      (genderData.series[0] / totalRunners) * 100
    )}%`;
    genderData.labels[1] += ` ${Math.round(
      (genderData.series[1] / totalRunners) * 100
    )}%`;

    categoryData.labels.forEach((label, index) => {
      categoryData.labels[index] =
        label +
        ` ${Math.round((categoryData.series[index] / totalRunners) * 100)}%`;
    });

    genderData.averageTimes.forEach((g, index) => {
      genderData.averageTimes[index] = moment(
        Math.round(
          genderData.averageTimes[index] /
            (genderData.series[index] - genderData.untimed[index])
        ) * 1000
      )
        .utc()
        .format("HH:mm:ss");
    });

    console.log(
      categoryData,
      genderData,
      totalRunners,
      genderData.averageTimes
    );
    return { categoryData, genderData, totalRunners };
  };

  onPublishRaceResults = (event, name) => {
    if (!this.state.raceDate) {
      this.triggerSnackbar("Please enter race date", "error");
      return;
    }
    if (!this.state.parsedResultsTableData) {
      this.triggerSnackbar("mmm, Can't find results", "error");
      return;
    }
    var results = {
      date: this.state.raceDate,
      //unparsedResults: this.state.unparsedResults,
      parsedResults: this.state.parsedResultsTableData[name],
      stats: this.calcStats(this.state.parsedResultsTableData[name])
    };

    firebase
      .database()
      .ref("races/" + this.state.raceDate)
      .set(results)
      .then(() => {
        var raceDatesRef = firebase.database().ref("raceDates");
        raceDatesRef.once("value", dates => {
          var d = dates.val();
          if (d[d.length - 1] !== this.state.raceDate) {
            d.push(this.state.raceDate);
            raceDatesRef.set(d);
          }
        });
        this.publishPersonalResults(this.state.parsedResultsTableData[name]);
      })
      .then(() => {
        this.triggerSnackbar("Results published", "success");
      })
      .catch(error => {
        this.triggerSnackbar(error.message, "error");
        console.error(error);
      });
  };

  publishPersonalResults = result => {
    const { raceDate, leagueData } = this.state;

    if (!leagueData) return;

    var parsedResults = result;

    parsedResults.forEach(r => {
      if (r[2] === "99999" || r[2] === 0) return;
      var user = leagueData[r[2]];
      if (!user) {
        this.triggerSnackbar(
          `Missing ${r}, results are published but not personal pages. Check leagueData`,
          "error"
        );
        console.log(leagueData[r[2]], r);
      }
      if (!user.events) {
        user.events = {};
      }
      user.events[raceDate] = r;
      Object.keys(user.events).forEach(raceDate => {
        if (r[5] !== "-" && (!user.pb || user.pb > r[5])) {
          user.pb = r[5];
        }
      });
    });

    console.log(leagueData);
    firebase
      .database()
      .ref("usersLeague")
      .set(this.leagueUpdate(leagueData))
      .catch(error => {
        this.triggerSnackbar(error.message, "error");
      });
  };

  leagueUpdate = league => {
    const { events } = this.state;
    var category = {};
    var genderMale = {};
    var genderFemale = {};
    var overall = {};

    league.forEach(user => {
      if (user) {
        user.pb = null;
        user.prevRanking = null;
        user.ranking = null;
      }
    });

    console.log(events);
    events.forEach(date => {
      category = {};
      overall = [];
      genderMale = [];
      genderFemale = [];

      league.forEach(user => {
        if (user) {
          if (user.events && user.events[date]) {
            // 1. Update PB
            if (user.pb) {
              var time = this.getNumberFromTime(user.events[date][5]);
              var pb = this.getNumberFromTime(user.pb);
              user.pb = time < pb ? user.events[date][5] : user.pb;
            } else {
              user.pb = user.events[date][5];
            }
            if (user.pb === "-") {
              user.pb = "59:59";
            }
          }
          if (user.pb) {
            overall.push(user);
            if (user.gender === "Male") {
              genderMale.push(user);
              if (category[`M${this.getAgeGroup(user.dob)}`]) {
                category[`M${this.getAgeGroup(user.dob)}`].push(user);
              } else {
                category[`M${this.getAgeGroup(user.dob)}`] = [user];
              }
            } else {
              genderFemale.push(user);
              if (category[`F${this.getAgeGroup(user.dob)}`]) {
                category[`F${this.getAgeGroup(user.dob)}`].push(user);
              } else {
                category[`F${this.getAgeGroup(user.dob)}`] = [user];
              }
            }
          }
          if (user.ranking) {
            user.prevRanking = user.ranking;
          }
        }
      }); // League
      overall.sort((a, b) => this.getSeconds(a.pb) - this.getSeconds(b.pb));
      genderMale.sort((a, b) => this.getSeconds(a.pb) - this.getSeconds(b.pb));
      genderFemale.sort(
        (a, b) => this.getSeconds(a.pb) - this.getSeconds(b.pb)
      );
      Object.keys(category).forEach(key => {
        category[key].sort(
          (a, b) => this.getSeconds(a.pb) - this.getSeconds(b.pb)
        );
      });

      overall.forEach((user, index) => {
        if (league[user.bibNumber]) {
          league[user.bibNumber].ranking = { overall: index + 1 };
        }
      });
      genderMale.forEach((user, index) => {
        if (league[user.bibNumber])
          league[user.bibNumber].ranking.gender = index + 1;
      });
      genderFemale.forEach((user, index) => {
        if (league[user.bibNumber])
          league[user.bibNumber].ranking.gender = index + 1;
      });
      Object.keys(category).forEach(key => {
        category[key].forEach((user, index) => {
          if (league[user.bibNumber])
            league[user.bibNumber].ranking.category = index + 1;
        });
      });
    });

    return league;
  };

  postPubicMessage = () => {
    firebase
      .database()
      .ref("publicMessages")
      .push({
        time: moment().format("YYYY-MM-DD hh:mm"),
        message: this.state.publicMessage
      })
      .then(() => {
        this.setState({ publicMessage: "" });
        this.triggerSnackbar("Message posted", "success");
      })
      .catch(error => {
        this.triggerSnackbar(error.message, "error");
      });
  };

  deleteComment = (rowsDeleted, data) => {
    const { commentsTableData } = this.state;
    rowsDeleted.data.forEach(del => {
      var msg = data[del.dataIndex][3];
      Object.keys(commentsTableData).forEach(key => {
        if (commentsTableData[key].message === msg) {
          firebase
            .database()
            .ref("deletedComments")
            .push(commentsTableData[key])
            .then(delete commentsTableData[key]);
        }
      });
    });

    firebase
      .database()
      .ref("comments")
      .set(commentsTableData)
      .then(this.triggerSnackbar("Comments Deleted", "success"));
  };

  newUserSubmit = event => {
    const email = document.getElementById("email").value;
    const password = document.getElementById("password").value;
    event.preventDefault();
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(() => {
        this.triggerSnackbar(`App access granted to  ${email}`, "success");
      })
      .catch(error => {
        this.triggerSnackbar(error.message, "error");
        console.error(error);
      });
  };

  // Add form dialog
  addResult = () => {
    if (!this.state.raceDate) {
      this.triggerSnackbar("Please select race date first", "error");
      return;
    }
    this.setState({ addResultDialogTrigger: true });
  };

  deleteResult = () => {
    if (!this.state.raceDate) {
      this.triggerSnackbar("Please select race date first", "error");
      return;
    }
    this.setState({ deleteResultDialogTrigger: true });
  };

  onDeleteResultDialogResponse = position => {
    const { parsedResultsTableData } = this.state;
    if (parsedResultsTableData) {
      console.log(
        this.state.parsedResultsTableData["Keypad only"][position - 1]
      );
    }
    this.setState({
      deleteResultDialogTrigger: false,
      parsedResultsTableData: []
    });

    if (parsedResultsTableData && position) {
      var key = this.state.parsedResultsTableData["Keypad only"][
        position - 1
      ][6];
      firebase
        .database()
        .ref(`raceResults/${this.state.raceDate}/numeric/${key}`)
        .set(null)
        .then(() => this.triggerSnackbar("deleted ", "success"));
    }
  };
  onAddResultDialogResponse = (bib, time) => {
    const ts = moment().valueOf();
    console.log(bib, time, ts);
    this.setState({
      addResultDialogTrigger: false,
      parsedResultsTableData: []
    });

    if (time && bib && (time.length === 7 || time.length === 5)) {
      firebase
        .database()
        .ref(`raceResults/${this.state.raceDate}/numeric/${ts}`)
        .update({ bibNumber: bib, clockTime: ts, finishTime: time })
        .then(() => {
          this.triggerSnackbar(
            `Added bib: ${bib}, time: ${time} \n Reload table to see changes`,
            "success"
          );
        })
        .catch(error => this.triggerSnackbar(error.message, "error"));
    } else {
      if (bib || time) {
        this.triggerSnackbar(
          "Please make sure you format the time correctly",
          "error"
        );
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        {this.state.snackbarTrigger && (
          <CustomizedSnackbar
            message={this.state.snackbarMessage}
            trigger={this.state.snackbarTrigger}
            variant={this.state.snackbarVariant}
            onClose={this.onSnackbarClose}
          />
        )}
        <AddResultDialog
          trigger={this.state.addResultDialogTrigger || false}
          onCancel={this.onAddResultDialogResponse}
          onSubmit={this.onAddResultDialogResponse}
        />
        <DeleteResultDialog
          trigger={this.state.deleteResultDialogTrigger || false}
          onCancel={this.onDeleteResultDialogResponse}
          onSubmit={this.onDeleteResultDialogResponse}
        />
        {this.state.loaded ? (
          this.state.authenticated ? (
            <React.Fragment>
              <Card className={classes.card}>
                <CardHeader title={"Actions"} className={classes.CardHeader} />
                <CardContent className={classes.cardContent}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Button
                        variant="outlined"
                        aria-label="logout"
                        color="primary"
                        size="small"
                        id="downloadDatabaseButton"
                        className={classes.button}
                        onClick={this.downloadDatabase}
                      >
                        <ArchiveIcon />
                        Download database
                      </Button>
                      {!this.state.loadingLastRace ? (
                        <Button
                          variant="outlined"
                          aria-label="loadLastRace"
                          color="primary"
                          size="small"
                          id="showTable"
                          className={classes.button}
                          onClick={this.loadLastRace}
                        >
                          <ScreenShareIcon />
                          Load last event
                        </Button>
                      ) : (
                        <React.Fragment>
                          <CircularProgress />
                          This might take a minute
                        </React.Fragment>
                      )}
                      <Button
                        variant="outlined"
                        aria-label="logout"
                        color="secondary"
                        size="small"
                        id="logoutButton"
                        className={classes.button}
                        onClick={this.logoutUser}
                      >
                        <ExitToAppIcon />
                        Logout
                      </Button>
                      <hr />
                    </Grid>
                    <Grid item xs={12} hidden>
                      <Button
                        variant="outlined"
                        aria-label="upload"
                        color="primary"
                        size="small"
                        id="showTable"
                        className={classes.button}
                        onClick={this.loadFromFile}
                      >
                        <AttachFileIcon />
                        Upload CSV
                      </Button>
                      <Input
                        id="files"
                        type="file"
                        onChange={event =>
                          this.setState({
                            csvFilePath: event.target.value
                          })
                        }
                      />
                      <hr />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        variant="outlined"
                        aria-label="upload"
                        color="primary"
                        size="small"
                        className={classes.button}
                        onClick={this.postPubicMessage}
                      >
                        <MessageIcon />
                        Post Message
                      </Button>
                      <TextField
                        id="publicMessage"
                        label="Public Message"
                        multiline
                        className={classes.textField}
                        value={this.state.message}
                        onBlur={event =>
                          this.setState({ publicMessage: event.target.value })
                        }
                        margin="dense"
                      />
                      <Grid item xs={12}>
                        <hr />
                        <TextField
                          type="date"
                          id="raceDate"
                          label="Event date"
                          onChange={event => {
                            this.setState({ raceDate: event.target.value });
                          }}
                          value={this.state.raceDate}
                        />
                        <Button
                          variant="outlined"
                          aria-label="logout"
                          color="secondary"
                          size="small"
                          id="showTable"
                          className={classes.button}
                          onClick={this.addResult}
                        >
                          <AddToQueue />
                          Add Result
                        </Button>
                        <Button
                          variant="outlined"
                          aria-label="logout"
                          color="primary"
                          size="small"
                          id="showTable"
                          className={classes.button}
                          onClick={this.deleteResult}
                        >
                          <RemoveFromQueue />
                          Delete Result
                        </Button>
                      </Grid>
                    </Grid>
                    {this.state.parsedResultsTableData &&
                      Object.keys(this.state.parsedResultsTableData).map(
                        name => {
                          return (
                            <Grid item xs={12} key={name}>
                              <div className={classes.fullWidth}>
                                <RaceResultsTable
                                  title={`Race results for ${name}`}
                                  data={this.state.parsedResultsTableData[name]}
                                />
                              </div>
                              <Button
                                variant="contained"
                                aria-label="Publish"
                                color="secondary"
                                id={`${name}`}
                                className={classes.button}
                                onClick={event =>
                                  this.onPublishRaceResults(event, name)
                                }
                              >
                                <PublishIcon />
                                Publish
                              </Button>
                              <div className={classes.gridItem}>
                                <hr />
                              </div>
                            </Grid>
                          );
                        }
                      )}
                  </Grid>
                </CardContent>
              </Card>
              <Card className={classes.card}>
                <CardHeader title={"Users "} className={classes.CardHeader} />
                <CardContent className={classes.cardContent}>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography component={"h4"}>
                        {`Registered Runners: ${this.state.usersTableData.length}`}
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails
                      className={classes.tablePanelWrapper}
                    >
                      {this.state.usersTableData.length !== 0 ? (
                        <div className={classes.tableDiv}>
                          <RunnersTable data={this.state.usersTableData} />
                        </div>
                      ) : (
                        <CircularProgress />
                      )}
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography component={"h4"}>
                        {`Comments: ${
                          Object.keys(this.state.commentsTableData).length
                        }`}
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails
                      className={classes.tablePanelWrapper}
                    >
                      {this.state.usersTableData.length !== 0 ? (
                        <div className={classes.tableDiv}>
                          <MessagesTable
                            data={Object.keys(this.state.commentsTableData).map(
                              key => {
                                var row = [];
                                row.push(
                                  this.state.commentsTableData[key].time,
                                  this.state.commentsTableData[key].name,
                                  this.state.commentsTableData[key].email,
                                  this.state.commentsTableData[key].message
                                );
                                return row;
                              }
                            )}
                            onRowDeleted={this.deleteComment}
                          />
                        </div>
                      ) : (
                        <CircularProgress />
                      )}
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography component={"h4"}>
                        Event participation
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails
                      className={classes.tablePanelWrapper}
                    >
                      <ul>
                        {this.state.eventsParticipation.map((row, index) => {
                          if (row !== 0) {
                            return <li key={index}> {`${index}: ${row}`} </li>;
                          }
                          return null;
                        })}
                      </ul>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </CardContent>
              </Card>
              <Card className={classes.card}>
                <CardHeader
                  title={"App Access"}
                  className={classes.CardHeader}
                />

                <CardContent className={classes.cardContent}>
                  <a
                    name="app download"
                    href="itms-services://?action=download-manifest&url=https://ggc5k.com/app/manifest.plist"
                    aria-label="Download App"
                  >
                    <Button
                      variant="outlined"
                      aria-label="DownloadApp"
                      color="primary"
                      size="small"
                      id="showTable"
                      className={classes.button}
                    >
                      <ExitToAppIcon />
                      Download Timing App
                    </Button>
                  </a>
                  <hr />
                  <Grid container>
                    <Typography variant="h6" className={classes.body1}>
                      Create new app user
                    </Typography>
                    <Grid item xs={12}>
                      <Typography variant="subtitle1" className={classes.body1}>
                        {"Email: "}
                        <Input id="email" />
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="subtitle1" className={classes.body1}>
                        {"Password: "}
                        <Input id="password" />
                      </Typography>
                    </Grid>
                    <Button
                      variant="outlined"
                      aria-label="DownloadApp"
                      color="primary"
                      size="small"
                      id="showTable"
                      className={classes.button}
                      onClick={this.newUserSubmit}
                    >
                      <VerifiedUserIcon />
                      Create new user
                    </Button>
                  </Grid>
                </CardContent>
              </Card>
            </React.Fragment>
          ) : this.state.volunteer ? (
            <React.Fragment>
              <Card className={classes.card}>
                <CardContent className={classes.cardContent}>
                  <Button
                    variant="outlined"
                    aria-label="logout"
                    color="secondary"
                    size="small"
                    id="showTable"
                    className={classes.button}
                    onClick={this.logoutUser}
                  >
                    <ExitToAppIcon />
                    Logout
                  </Button>
                  <a
                    href="itms-services://?action=download-manifest&url=https://ggc5k.com/app/manifest.plist"
                    aria-label="Download app"
                  >
                    <Button
                      variant="outlined"
                      aria-label="DownloadApp"
                      color="primary"
                      size="small"
                      id="showTable"
                      className={classes.button}
                    >
                      <ExitToAppIcon />
                      Download Timing App
                    </Button>
                  </a>
                </CardContent>
              </Card>
            </React.Fragment>
          ) : (
            <SignIn />
          )
        ) : (
          <CircularProgress />
        )}
      </React.Fragment>
    );
  }
}

Webmaster.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Webmaster);
